import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import { listSolutions, listSystems, getSystem } from "../utils/utilsSolution";



class SelectSystem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.handleChange = this.handleChange.bind(this);
    

    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    
    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectSolution: false,
            label: "System",
            idSelected: "",
            idSolution: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectSolution = getParam('selectSolution',this.props);
        StateChange.idSolution = getParam('idSolution', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectSolution){
            this.loadSolutions();
        }

        if (StateChange.idSolution){
            this.loadSystems(StateChange.idSolution);
        }

        if (StateChange.idSelected){
            this.loadSelectedSystem(StateChange.idSelected);
        }

        this.setState(StateChange);

    }

    loadSelectedSystem(idSystem){
        
        if (!idSystem){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (System) => {
            const StateChange = {
                SelectedSystem: System,
                renderState: "loaded"
            };
            
            if (System.Solution){
                StateChange.idSolution = System.Solution._id;
                this.loadSystems(StateChange.idSolution);
            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load System"
            });
        };

        getSystem(this.dsd, idSystem, onLoad, onFail);

        return;           
    };



    loadSystems(idSolution){

        const onLoad = (data) => {
            this.setState({
                isLoadedSystems: true,
                renderState: 'loaded',
                Systems: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedSystems: false
            });
        }

        this.setState({renderState: 'loading'})
        listSystems(this.dsd, {idSolution:idSolution}, onLoad, onFail);
        return;
        
    };

    loadSolutions(){

        const onLoad = (data) => {
            this.setState({
                isLoadedSolutions: true,
                renderState: 'loaded',
                Solutions: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedSolutions: false
            });
        }

        this.setState({renderState: 'loading'})
        listSolutions(this.dsd, {}, onLoad, onFail);
        return;
        
    };

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idSolution":
                this.setState({"idSolution":FormFieldValue});
                if (FormFieldValue){
                    this.loadSystems(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectSolution && this.state.isLoadedSolutions &&
                            <PD.Select label='Select a Solution' name='idSolution' onChange={this.handleChange} value={this.state.idSolution}>
                                {
                                    this.state.Solutions.map(
                                        (Solution, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Solution._id}>{Solution.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.isLoadedSystems &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Systems.map(
                                        (System, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={System._id}>{System.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectSystem_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectSystem {...props} navigation={navigation} location={location} params={params} />;
  }
